module.exports = __webpack_public_path__ + "img/ADDRESS.60aa80d3.svg";